import React from 'react';
import propTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import styled from 'styled-components';

export const B = styled.b`
  display: block;
  margin-bottom: 5px;
`;

export const Dash = ({ spaced }) => (
  <span>
    {spaced && ' '}&mdash;{spaced === 'both' && ' '}
  </span>
);
Dash.propTypes = { spaced: propTypes.oneOfType([propTypes.bool, propTypes.string]) };

export const Center = styled.div`
  text-align: center;
`;

export const Column = styled(Grid.Column)`
  padding-top: 5px !important;
  padding-bottom: 5px !important;
`;

export const SpanCentered = styled.span`
  display: inline-block;
  padding-top: 20px !important;
  text-align: center;
`;

export const StyledGrid = styled(Grid)`
  width: 100%;
  padding: 0 !important;
  margin: 0 !important;
`;

export const StyledLabel = styled.label`
  display: block;
  margin: 0 0 0.28571429rem 0;
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.92857143em;
  font-weight: 700;
  text-transform: none;
`;

export const StyledLabelsContainer = styled.div`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-block;
`;

export const StyledNotesContainer = styled.div`
  border-top: 1px solid #ccc;
  margin-left: -14px;
  margin-right: -14px;
`;

export const StyledTipologia = styled.div`
  color: #666;
  text-transform: uppercase;
  font-size: 10px;
  margin-bottom: -5px;
`;

export const StyledTitleContainer = styled.div`
  display: inline-block;
`;



// WEBPACK FOOTER //
// ./app/components/Layout/index.js